/**
 * 调试参数（对应 iOS DevHooks，只在开发构建 npm run dev 中生效），方便用 Playwright 直接打开某个页面 / 弹窗截图：
 *   ?dev_tab=learn         启动后跳到对应页面（home / schedule / learn / achieve / me / assistant / mcp）
 *   ?dev_sheet=assign      页面用 useDevSheet("assign") 判断是否自动打开某个弹窗（每次加载只触发一次）
 */
import { useState } from "react";

const enabled = import.meta.env.DEV;
const initial = typeof location !== "undefined" ? new URLSearchParams(location.search) : new URLSearchParams();
const used = new Set<string>();

/** 读取启动时 URL 上的调试参数（生产构建总是 null） */
export function devParam(name: string): string | null {
  return enabled ? initial.get(name) : null;
}

export function devTab(): string | null {
  return devParam("dev_tab");
}

export function devSheet(): string | null {
  return devParam("dev_sheet");
}

/** ?dev_sheet 等于 name 时返回 true，每次页面加载只返回一次 */
export function takeDevSheet(name: string): boolean {
  if (devSheet() !== name || used.has(`sheet:${name}`)) return false;
  used.add(`sheet:${name}`);
  return true;
}

/** 某个调试动作每次页面加载只做一次 */
export function takeOnce(name: string): boolean {
  if (!enabled || used.has(name)) return false;
  used.add(name);
  return true;
}

/** 弹窗的初始打开状态：const [open, setOpen] = useDevSheet("assign") */
export function useDevSheet(name: string): [boolean, (open: boolean) => void] {
  return useState(() => takeDevSheet(name));
}

/** dev_tab 对应的路由 */
export const DEV_TAB_PATHS: Record<string, string> = {
  home: "/",
  schedule: "/schedule",
  learn: "/learn",
  achieve: "/achieve",
  me: "/me",
  assistant: "/assistant",
  mcp: "/me/mcp",
};
